<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";


    export let transfer;
    export let onClose = () => {
    };

    let email = transfer.customer.email;
    let markAdNotified = transfer.notified_at == null ? 1 : 0;
    let emailSent = false;

    const sendNotification = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const onSuccess = result => {
            if (markAdNotified == 1) {
                transfer.notified_at = formatDate(new Date(), 'd-m-y');
            }
            Notifier.showMessage("Email sent successfully");
            emailSent = true;
        };

        const onFailure = err => {
            Notifier.showError("Could not send email to customer!");
        };

        R.handle(R.transfer.send_notification_email, {
            id: transfer.id,
            email,
            mark_as_notified: markAdNotified,
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        onClose();
    }
</script>

{#if transfer}
    <Modal modalSm title="Send notification mail" on:close={close}>
        <div slot="body">
            <form on:submit={sendNotification}>
                <p>
                    <span class="text-warning-emphasis fw-semibold">Warning</span><br>
                    Transfer data must be saved before sending email to customer.
                </p>
                <div class="form-group">
                    <label>Send mail to</label>
                    <input type="email" class="form-control" bind:value={email} required>
                </div>
                <div class="form-group">
                    <Checkbox label={`Mark as "Notified"`} bind:checked={markAdNotified} />
                </div>
                <div class="text-end">
                    {#if !emailSent}
                        <button type="button" class="btn btn-link me-2" on:click={close}>Cancel</button>
                        <button type="submit" class="btn btn-primary px-4">Send mail</button>
                    {:else}
                        <button type="button" class="btn btn-link me-2" on:click={close}>Close</button>
                    {/if}
                </div>
            </form>
        </div>
    </Modal>
{/if}
